// TODO enable eslint
/* eslint-disable react/sort-comp */
/* eslint-disable react/destructuring-assignment */
import React, { PureComponent } from "react"
import { findDOMNode } from "react-dom"
import { Portal } from "react-portal"
import PropTypes from "prop-types"
import { CSSTransition, TransitionGroup } from "react-transition-group"
import cn from "classnames"
import isFunction from "lodash/isFunction"
import { TAB } from "./lib/keyCodes"
import captureNextEvent from "./lib/captureNextEvent"
import { addTouchEvent, removeTouchEvent } from "./lib/touches"
import Tooltip from "./Tooltip"
import styles from "./styles.css"

function getContainer(tooltip) {
  return tooltip.parentNode
}

class TooltipContainer extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    container: PropTypes.func,
    delay: PropTypes.number,
    enterTimeout: PropTypes.number,
    label: PropTypes.node.isRequired,
    leaveTimeout: PropTypes.number,
    position: Tooltip.propTypes.position,
    style: PropTypes.shape({}),
    target: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.func]),
    tooltipClassName: PropTypes.string,
    tooltipFixed: PropTypes.bool,
    tooltipStyle: PropTypes.shape({}),
  }

  static defaultProps = {
    className: ``,
    container: getContainer,
    delay: 0,
    enterTimeout: 150,
    leaveTimeout: 150,
    position: `bottom`,
    style: {},
    target: null,
    tooltipClassName: ``,
    tooltipFixed: false,
    tooltipStyle: {},
  }

  state = {
    fixedStyle: {},
    visible: false,
  }

  componentDidMount() {
    this.setTarget()
  }

  componentDidUpdate(prevProps) {
    if (this.props.target !== prevProps.target) {
      this.setTarget()
    }
  }

  componentWillUnmount() {
    this.unlinkTarget()
    this.target = null

    if (this.delayedTimeout) {
      clearTimeout(this.delayedTimeout)
    }
  }

  setTarget = () => {
    const { container } = this
    let { target } = this.props

    this.unlinkTarget()

    if (isFunction(target)) {
      target = target(container, this)
    }

    /* eslint-disable-next-line react/no-find-dom-node */
    target = target ? findDOMNode(target) : container
    this.target = target || null

    if (target) {
      addTouchEvent(target, `start`, this.showTooltip)
      addTouchEvent(target, `end`, this.hideTooltip)
      target.addEventListener(`mouseover`, this.showTooltip)
      target.addEventListener(`mouseleave`, this.hideTooltip)
      target.addEventListener(`keyup`, this.handleKeyUp)
      target.addEventListener(`blur`, this.hideTooltip)
    }
  }

  setContainers = div => {
    if (div) {
      this.container = this.props.container(div.parentNode, this)
    }
  }

  delayedTimeout = null

  unlinkTarget = () => {
    const { target } = this

    if (target) {
      removeTouchEvent(target, `start`, this.showTooltip)
      removeTouchEvent(target, `end`, this.hideTooltip)
      target.removeEventListener(`mouseover`, this.showTooltip)
      target.removeEventListener(`mouseleave`, this.hideTooltip)
      target.removeEventListener(`keyup`, this.handleKeyUp)
      target.removeEventListener(`blur`, this.hideTooltip)
    }
  }

  stopContextMenu = e => {
    e.preventDefault()
    window.removeEventListener(`contextmenu`, this.stopContextMenu, true)
    captureNextEvent(`click`)
    this.setState({ visible: true })
  }

  showTooltip = e => {
    if (e.type === `mouseover` && this.touched) {
      return
    }

    if (e.type === `touchstart`) {
      this.touched = true

      window.addEventListener(`contextmenu`, this.stopContextMenu, true)
      return
    }

    const { delay, tooltipFixed } = this.props

    if (tooltipFixed && this.target) {
      const bounds = this.target.getBoundingClientRect()

      this.setState({
        fixedStyle: {
          display: `inline-block`,
          left: `${bounds.x + bounds.width + 12}px`,
          position: `fixed`,
          top: `${bounds.top + bounds.height / 2}px`,
          width: `auto`,
          zIndex: 550,
        },
      })
    }

    if (this.delayedTimeout) {
      clearTimeout(this.delayedTimeout)
    }

    if (delay) {
      this.delayedTimeout = setTimeout(() => {
        this.delayedTimeout = null

        this.setState({ visible: true })
      }, delay)
    } else {
      this.setState({ visible: true })
    }
  }

  hideTooltip = e => {
    if (this.delayedTimeout) {
      clearTimeout(this.delayedTimeout)
    }

    if (e.type === `mouseover` && this.touched) {
      return
    }

    this.setState({ visible: false })
  }

  handleKeyUp = e => {
    if ((e.which || e.keyCode) === TAB) {
      this.showTooltip(e)
    }
  }

  render() {
    const { fixedStyle, visible } = this.state
    const {
      className,
      enterTimeout,
      label,
      leaveTimeout,
      position,
      style,
      tooltipClassName,
      tooltipFixed,
      tooltipStyle,
    } = this.props
    const tooltipStyleExtended = tooltipFixed
      ? {
          ...tooltipStyle,
          right: 0,
          left: 0,
          position: `relative`,
        }
      : tooltipStyle

    const tooltip = (
      <Tooltip
        key="tooltip"
        style={tooltipStyleExtended}
        className={tooltipClassName}
        position={position}
      >
        {label}
      </Tooltip>
    )

    if (tooltipFixed) {
      return (
        <TransitionGroup
          style={style}
          className={cn(styles.container, className)}
        >
          <CSSTransition
            timeout={{
              enter: enterTimeout,
              exit: leaveTimeout,
            }}
            classNames={{
              appear: styles.enter,
              enter: styles.enter,
              exit: styles.leave,
            }}
            appear
          >
            <div ref={this.setContainers}>
              {visible && (
                <Portal isOpened>
                  <div style={fixedStyle}>{tooltip}</div>
                </Portal>
              )}
            </div>
          </CSSTransition>
        </TransitionGroup>
      )
    }

    return (
      <TransitionGroup
        style={style}
        className={cn(styles.container, className)}
      >
        <CSSTransition
          timeout={{
            enter: enterTimeout,
            exit: leaveTimeout,
          }}
          classNames={{
            appear: styles.enter,
            enter: styles.enter,
            exit: styles.leave,
          }}
          appear
        >
          <div ref={this.setContainers}>{visible ? tooltip : null}</div>
        </CSSTransition>
      </TransitionGroup>
    )
  }
}

export default TooltipContainer
